export const increment = (target) => {
  const el = {
    buttons: target.querySelectorAll('.increment__button'),
    amount: target.querySelector('.increment__amount'),
  }

  const method = {
    init: () => {
      el.buttons.forEach((button) => {
        button.addEventListener('click', (event) => method.handleClick(event))
      })
    },

    handleClick: (event) => {
      const isDecreaseButton = event.target.classList.contains('increment__button--decrease')
      const isIncreaseButton = event.target.classList.contains('increment__button--increase')
      let value = Number(el.amount.value)

      if (isDecreaseButton) {
        el.amount.value = value.toString()

        if (value > 1) {
          value--
          el.amount.value = value.toString()
        }
      }

      if (isIncreaseButton) {
        value++
        el.amount.value = value.toString()
      }
    },
  }

  method.init()
}
